<script>
    import Accordian from '$lib/components/Accordian.svelte';
    import AccordianItem from '$lib/components/AccordianItem.svelte';
    import PortableText from '$lib/components/PortableText.svelte';

    export let content = [];
    export let modulePosition;
    export let sectionPosition;

    // Style
    let moduleStyle = '';
    switch (content?.style) {
        case 'None':
            moduleStyle = '';
            break;
        case 'Framed':
            moduleStyle = 'rounded-xl border border-base-900/5 bg-base-900 p-4 shadow-sm lg:p-8';
            break;
        case 'Gradient Framed':
            moduleStyle = 'featured-gradient rounded-xl p-4 shadow-sm lg:p-8';
            break;
        default:
            moduleStyle = '';
            break;
    }
</script>

<div class={moduleStyle} data-moduleposition={modulePosition}>
    <Accordian classes="divide-y divide-color-text/10 first:-mt-4 last:-mb-4 lg:first:-mt-6 lg:last:-mb-6">
        {#each content?.items as item, index (item)}
            <AccordianItem accordianOpen={item?.open} key={index}>
                <svelte:element this={item?.titleType} slot="header" class=" py-4 text-left font-semibold lg:text-xl">{item?.title}</svelte:element>
                <div slot="body" class="py-6 text-left">
                    <PortableText data={item?.body} />
                </div>
            </AccordianItem>
        {/each}
    </Accordian>
</div>
